import { render, staticRenderFns } from "./MedicaidIdFormatSelector.vue?vue&type=template&id=a2635b7a&scoped=true"
import script from "./MedicaidIdFormatSelector.vue?vue&type=script&lang=js"
export * from "./MedicaidIdFormatSelector.vue?vue&type=script&lang=js"
import style0 from "./MedicaidIdFormatSelector.vue?vue&type=style&index=0&id=a2635b7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2635b7a",
  null
  
)

export default component.exports